export default "__VITE_ASSET__42610f08__"